import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SgsstAuthUserService } from '../modules/shared/services/auth.service';
import { UserDTO } from '../interfaces/base-entity';
import { UserRoleEnum } from '../enums/enums';
import { BlockUIService } from '../modules/shared/services/blockUI.service';
import { UserRoleService } from '../utils/user-role.service';
import { StorageService } from '../modules/shared/services/storage.service';
import { hasValidTenantContext } from '../utils/session-tenant-context.util';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  loginDisplay = false;
  displayedColumns: string[] = ['claim', 'value'];
  dataSource: any = [];
  public blockUI: BlockUIService = inject(BlockUIService);
  private userRoleService: UserRoleService = inject(UserRoleService);
  private storage = inject(StorageService);
  currentUser: UserDTO = {} as UserDTO;
  private authUserService: SgsstAuthUserService = inject(SgsstAuthUserService);
  constructor(public router: Router) {}

  ngOnInit(): void {
    this.authUserService.userLoggedIn$.subscribe((user: UserDTO | null) => {
      this.currentUser = user ?? ({} as UserDTO);
    });
  }

  get showPortalContent(): boolean {
    if (this.authUserService.isTenantResolutionPending) {
      return false;
    }
    return hasValidTenantContext(this.storage);
  }

  isAdmin() {
    return (
      this.userRoleService.getRoleEnum() === UserRoleEnum.AdminWorkCenter ||
      this.userRoleService.getRoleEnum() === UserRoleEnum.AdminCompany ||
      this.userRoleService.getRoleEnum() === UserRoleEnum.Root
    );
  }

  isUser() {
    return this.userRoleService.getRoleEnum() === UserRoleEnum.Employee;
  }

  getUserRoleDisplay(): string {
    const role = this.userRoleService.getRole();
    return role?.roleName || 'Usuario';
  }

  getRoleSeverity(): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    const role = this.userRoleService.getRoleEnum();

    if (role === UserRoleEnum.Root) {
      return 'danger';
    }

    if (role === UserRoleEnum.AdminCompany || role === UserRoleEnum.AdminWorkCenter) {
      return 'warning';
    }

    if (role === UserRoleEnum.Employee) {
      return 'info';
    }

    return 'info';
  }
}
